import React from 'react'
import { toggleNav } from 'scripts/components/navigations/helpers/NavigationHelpers'
import { dispatcher } from 'scripts/components/navigations/NavigationDispatcher'
import subnavigation from 'scripts/components/navigations/SubNavigation'
import Constants from 'scripts/base/Constants'
import PropTypes from 'prop-types'
import Login from './login'
import locale from 'parent/i18n/react'
export default class DropdownComponent extends React.Component {
  constructor(props) {
    super(props)
    this.updateDom = this.updateDom.bind(this)
  }

  updateDom(data) {
    if (data.id === this.props.id) {
      toggleNav({ hidden: true, component: this }, data, this.props)
    }
  }

  componentDidMount() {
    dispatcher.on(Constants.Navigations.TOGGLE_NAV_CLASS, this.updateDom)
  }

  componentWillUnmount() {
    dispatcher.off(Constants.Navigations.TOGGLE_NAV_CLASS, this.updateDom)
  }

  render() {
    const LoginForm = subnavigation(Login)
    return (
      <div className={`navbar-dropdown hidden login-dropdown`}>
        <div>{locale.login.title}</div>
        <LoginForm {...this.props} />
      </div>
    )
  }
}

DropdownComponent.propTypes = {
  id: PropTypes.string.isRequired,
  toggleWithId: PropTypes.func,
  dropdown: PropTypes.string,
  navList: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./assets/js/lib/firebase/DropdownComponent.jsx